import { render, staticRenderFns } from "./CustomAttributeSelector.vue?vue&type=template&id=00400afb&scoped=true&"
import script from "./CustomAttributeSelector.vue?vue&type=script&lang=js&"
export * from "./CustomAttributeSelector.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttributeSelector.vue?vue&type=style&index=0&id=00400afb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00400afb",
  null
  
)

export default component.exports